import React from 'react';

import { miniGazelle } from '../../../../../helpers';
import ProLink from '../../../../shared/ProLink/ProLink';

const ProductGrid = ({ products, productWrapperClasses }) => (
    <div className={productWrapperClasses} data-testid="product-grid">
        {products.map((product, i) => (
            <div key={i} className="product-block">
                <ProLink to={product.link} className="block-link">
                    <div className="product-image">
                        {(product.isNewProduct || product.isNewProductBasisPim) && (
                            <span className="label label-warning smaller-sup is-new">
                                {miniGazelle.label('isNewProduct', true)}
                            </span>
                        )}
                        <picture>
                            <img src={product.thumbnail} alt="" role="presentation" />
                        </picture>
                    </div>
                    <div className="product-name">
                        <span className="header-bold">
                            {product.name}{' '}
                            {product.isDiscontinued && (
                                <span className="label label-warning smaller-sup discontinued-label">
                                    {miniGazelle.label('isDiscontinued', true)}
                                </span>
                            )}
                        </span>
                    </div>
                    <div className="product-descriptors" aria-hidden={true}>
                        <p dangerouslySetInnerHTML={{ __html: product.description }} />
                    </div>
                </ProLink>
            </div>
        ))}
    </div>
);

export default ProductGrid;
